/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { Login1 } from '@manulife/mux-cds-icons';
import PropTypes from 'prop-types';
import i18n from '../../../lang/i18n/index.js';
import { safeRest, noop } from '../../../utils/functions.js';
import { SIGN_IN_VARIANT } from '../constants.js';
import HeaderButton from './HeaderButton.js';
import { SignInComponent } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../../hooks/useTheme.js';
import useLang from '../../../hooks/useLang.js';
import useNavigation from '../../../hooks/useNavigation.js';

var _excluded = ["id", "label", "icon", "onClick", "children"];
var SignIn = function SignIn(_ref) {
  var id = _ref.id,
    label = _ref.label,
    icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === undefined ? noop : _ref$onClick,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var lang = useLang();
  var safeProps = safeRest(rest);
  var _useNavigation = useNavigation(),
    isSignedIn = _useNavigation.isSignedIn;
  var variant = theme.sideNav.mobile.signIn.variant;
  return /*#__PURE__*/jsx(HeaderButton, _objectSpread(_objectSpread({
    id: id,
    label: label || (isSignedIn ? i18n[lang].utilityHeader.profileLabel : i18n[lang].utilityHeader.signInLabel),
    icon: icon || variant === SIGN_IN_VARIANT.GOLD && /*#__PURE__*/jsx(Login1, {
      "aria-hidden": true,
      title: "login-icon"
    }),
    onClick: onClick,
    showMenuArrow: false,
    isSignedIn: isSignedIn,
    variant: variant,
    as: SignInComponent,
    forwardedAs: rest.as
    // Since "as" prop is used for providing styling here, "forwardedAs" will update the underlying DOM element
    // if needed, while keeping the styling of SignInComponent. This allows "as" to be used consistently
    // for all HeaderButtons
  }, safeProps), {}, {
    children: children
  }), "signin");
};
process.env.NODE_ENV !== "production" ? SignIn.propTypes = {
  /** id for the DOM element */
  id: PropTypes.string,
  /** label displayed on Sign in button */
  label: PropTypes.node,
  /** icon for Sign in button */
  icon: PropTypes.node,
  /** onClick handler for Sign in button */
  onClick: PropTypes.func,
  /** one or more menu items added using the MenuItem component */
  children: PropTypes.node
} : undefined;
process.env.NODE_ENV !== "production" ? SignIn.displayName = 'SignIn' : undefined;

export { SignIn as default };
